module.exports = __webpack_public_path__ + "img/strelki2.7497ec4d.png";